var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_764",
    "data-name": "Group 764",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 145.466,
    height: 140.328,
    viewBox: "0 0 145.466 140.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #002353;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #c7d11d;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #00973d;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    className: "cls-1",
    width: 145.466,
    height: 140.328
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3064",
    "data-name": "Path 3064",
    className: "cls-3",
    d: "M2.621,177.88H2.393A2.351,2.351,0,0,1,0,175.525a2.383,2.383,0,0,1,2.393-2.392h.228v-1.291A6.717,6.717,0,0,1,4.254,166.9a6.333,6.333,0,0,1,4.671-1.6,14.089,14.089,0,0,1,2.355.152,2.347,2.347,0,0,1,1.975,2.317A2.4,2.4,0,0,1,10.9,170.17h-.493c-1.329,0-2.089.684-2.089,2.2v.8h2.507a2.355,2.355,0,1,1,0,4.709H8.393v12.761a2.886,2.886,0,0,1-5.773,0Z",
    transform: "translate(0 -65.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    className: "cls-3",
    d: "M31.323,198.512c-6.114,0-10.633-4.292-10.633-10.52v-.076c0-5.811,4.139-10.6,10.064-10.6a9.623,9.623,0,0,1,9.8,9.8,2.634,2.634,0,0,1-2.7,2.773H26.424a4.721,4.721,0,0,0,4.975,3.987,6.664,6.664,0,0,0,4.1-1.367,2.153,2.153,0,0,1,1.4-.456,2.207,2.207,0,0,1,2.241,2.279,2.267,2.267,0,0,1-.759,1.709,10.549,10.549,0,0,1-7.064,2.468m3.722-12.229c-.342-2.583-1.861-4.329-4.291-4.329-2.393,0-3.95,1.709-4.405,4.329Z",
    transform: "translate(-8.194 -70.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    className: "cls-3",
    d: "M55.842,180.457a2.886,2.886,0,0,1,5.773,0v.911c.835-1.975,2.2-3.8,3.912-3.8a2.789,2.789,0,0,1,.646,5.507c-2.924.684-4.558,2.924-4.558,7.026V195.5a2.886,2.886,0,0,1-5.773,0Z",
    transform: "translate(-22.115 -70.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    className: "cls-3",
    d: "M78.356,180.457a2.886,2.886,0,1,1,5.773,0v.911c.835-1.975,2.2-3.8,3.912-3.8a2.789,2.789,0,0,1,.646,5.507c-2.924.684-4.558,2.924-4.558,7.026V195.5a2.886,2.886,0,1,1-5.773,0Z",
    transform: "translate(-31.032 -70.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    className: "cls-3",
    d: "M97.285,192.307v-.076c0-4.443,3.38-6.494,8.2-6.494a14.455,14.455,0,0,1,4.975.836v-.342c0-2.393-1.481-3.722-4.367-3.722a13.241,13.241,0,0,0-3.988.57,2.449,2.449,0,0,1-.835.152,2.35,2.35,0,0,1-2.392-2.354,2.392,2.392,0,0,1,1.557-2.241,17.717,17.717,0,0,1,6.494-1.064c3.152,0,5.431.835,6.874,2.279,1.519,1.519,2.2,3.76,2.2,6.494v9.267a2.772,2.772,0,0,1-2.81,2.772,2.585,2.585,0,0,1-2.773-2.393v-.037a7.825,7.825,0,0,1-6.152,2.582c-3.836,0-6.988-2.2-6.988-6.228m13.255-1.329v-1.026a8.956,8.956,0,0,0-3.684-.759c-2.469,0-3.988.987-3.988,2.81v.076c0,1.557,1.291,2.468,3.152,2.468,2.7,0,4.519-1.482,4.519-3.57",
    transform: "translate(-38.528 -70.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    className: "cls-3",
    d: "M131.01,188.971v-9.647h-.19a2.468,2.468,0,1,1,0-4.937h.19v-2.545a2.886,2.886,0,1,1,5.773,0v2.545h2.545a2.468,2.468,0,0,1,0,4.937h-2.545v8.7c0,1.329.57,1.975,1.861,1.975.19,0,.57-.038.684-.038a2.407,2.407,0,0,1,2.393,2.392,2.349,2.349,0,0,1-1.482,2.165,8.526,8.526,0,0,1-3.3.57c-3.531,0-5.924-1.405-5.924-6.115",
    transform: "translate(-50.831 -66.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    "data-name": "Path 3070",
    className: "cls-3",
    d: "M148.411,187.991v-.076a10.684,10.684,0,0,1,11.052-10.6c6.3,0,10.975,4.672,10.975,10.52v.076a10.684,10.684,0,0,1-11.051,10.6c-6.3,0-10.976-4.671-10.976-10.52m16.331,0v-.076a5.408,5.408,0,0,0-5.355-5.621,5.215,5.215,0,0,0-5.279,5.544v.076a5.409,5.409,0,0,0,5.355,5.621,5.215,5.215,0,0,0,5.279-5.545",
    transform: "translate(-58.776 -70.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    className: "cls-3",
    d: "M188.029,180.457a2.886,2.886,0,0,1,5.773,0v.911c.835-1.975,2.2-3.8,3.912-3.8a2.789,2.789,0,0,1,.646,5.507c-2.924.684-4.558,2.924-4.558,7.026V195.5a2.886,2.886,0,0,1-5.773,0Z",
    transform: "translate(-74.466 -70.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    className: "cls-3",
    d: "M218.6,198.512c-6.114,0-10.633-4.292-10.633-10.52v-.076c0-5.811,4.14-10.6,10.064-10.6a9.623,9.623,0,0,1,9.8,9.8,2.634,2.634,0,0,1-2.7,2.773H213.7a4.72,4.72,0,0,0,4.975,3.987,6.663,6.663,0,0,0,4.1-1.367,2.156,2.156,0,0,1,1.405-.456,2.207,2.207,0,0,1,2.241,2.279,2.267,2.267,0,0,1-.759,1.709,10.55,10.55,0,0,1-7.065,2.468m3.722-12.229c-.342-2.583-1.861-4.329-4.291-4.329-2.393,0-3.951,1.709-4.406,4.329Z",
    transform: "translate(-82.361 -70.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    className: "cls-3",
    d: "M3.132,226.548l3.07-6.713a.559.559,0,0,1,.541-.378h.043a.545.545,0,0,1,.53.378l3.07,6.7a.578.578,0,0,1,.054.216.411.411,0,0,1-.411.411.466.466,0,0,1-.422-.313l-.789-1.74H4.667l-.789,1.762a.428.428,0,0,1-.411.292.387.387,0,0,1-.389-.389.489.489,0,0,1,.054-.227m5.351-2.216-1.741-3.87L5,224.332Z",
    transform: "translate(-1.219 -86.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    className: "cls-3",
    d: "M25.5,220.033a.431.431,0,0,1,.421-.432h2.411c1.708,0,2.832.908,2.832,2.4v.022c0,1.633-1.362,2.476-2.973,2.476H26.349v2.291a.427.427,0,1,1-.854,0Zm2.724,3.686c1.254,0,2.076-.67,2.076-1.665v-.022c0-1.081-.811-1.643-2.032-1.643H26.349v3.33Z",
    transform: "translate(-10.097 -86.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    className: "cls-3",
    d: "M43.007,226.548l3.071-6.713a.558.558,0,0,1,.541-.378h.043a.545.545,0,0,1,.53.378l3.07,6.7a.578.578,0,0,1,.054.216.41.41,0,0,1-.411.411.465.465,0,0,1-.422-.313l-.789-1.74H44.542l-.789,1.762a.427.427,0,0,1-.411.292.387.387,0,0,1-.389-.389.5.5,0,0,1,.054-.227m5.351-2.216-1.74-3.87-1.741,3.87Z",
    transform: "translate(-17.011 -86.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    className: "cls-3",
    d: "M65.37,220.032a.431.431,0,0,1,.422-.432h2.832a2.984,2.984,0,0,1,2.151.757,2.09,2.09,0,0,1,.584,1.492v.022a2.2,2.2,0,0,1-2.021,2.194l1.881,2.422a.465.465,0,0,1,.141.313.447.447,0,0,1-.432.422.5.5,0,0,1-.4-.227L68.4,224.227H66.224v2.562a.427.427,0,1,1-.854,0Zm3.178,3.427c1.135,0,1.946-.584,1.946-1.556v-.022c0-.93-.713-1.492-1.935-1.492H66.224v3.07Z",
    transform: "translate(-25.889 -86.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    className: "cls-3",
    d: "M87.321,220.389H85.126a.4.4,0,0,1-.4-.389.407.407,0,0,1,.4-.4H90.38a.407.407,0,0,1,.4.4.4.4,0,0,1-.4.389H88.186v6.4a.432.432,0,0,1-.865,0Z",
    transform: "translate(-33.554 -86.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    className: "cls-3",
    d: "M102.489,226.548l3.07-6.713a.559.559,0,0,1,.541-.378h.043a.545.545,0,0,1,.53.378l3.07,6.7a.578.578,0,0,1,.054.216.411.411,0,0,1-.411.411.466.466,0,0,1-.422-.313l-.789-1.74h-4.151l-.789,1.762a.428.428,0,0,1-.411.292.387.387,0,0,1-.389-.389.489.489,0,0,1,.054-.227m5.351-2.216-1.741-3.87-1.74,3.87Z",
    transform: "translate(-40.568 -86.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    className: "cls-3",
    d: "M124.852,219.968a.429.429,0,0,1,.422-.422h.1a.468.468,0,0,1,.4.227l2.7,4.065,2.7-4.065a.457.457,0,0,1,.4-.227h.1a.429.429,0,0,1,.422.422v6.8a.431.431,0,0,1-.422.432.441.441,0,0,1-.432-.432v-5.643l-2.421,3.557a.419.419,0,0,1-.357.216.438.438,0,0,1-.368-.216l-2.41-3.546v5.643a.416.416,0,1,1-.832,0Z",
    transform: "translate(-49.446 -86.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    className: "cls-3",
    d: "M147.913,226.735v-6.7a.431.431,0,0,1,.422-.432h4.7a.389.389,0,0,1,0,.779h-4.27v2.583h3.783a.4.4,0,0,1,.39.39.388.388,0,0,1-.39.389h-3.783v2.648h4.324a.389.389,0,1,1,0,.779h-4.756a.431.431,0,0,1-.422-.432",
    transform: "translate(-58.579 -86.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    className: "cls-3",
    d: "M167.43,219.953a.429.429,0,0,1,.422-.422h.119a.522.522,0,0,1,.432.249L173,225.64v-5.708a.416.416,0,1,1,.832,0v6.832a.384.384,0,0,1-.389.4H173.4a.587.587,0,0,1-.443-.259l-4.692-6v5.859a.416.416,0,1,1-.832,0Z",
    transform: "translate(-66.308 -86.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    className: "cls-3",
    d: "M190.706,220.389h-2.195a.4.4,0,0,1-.4-.389.406.406,0,0,1,.4-.4h5.254a.407.407,0,0,1,.4.4.4.4,0,0,1-.4.389h-2.194v6.4a.432.432,0,0,1-.865,0Z",
    transform: "translate(-74.498 -86.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3083",
    "data-name": "Path 3083",
    className: "cls-3",
    d: "M206.8,223.32V223.3a3.86,3.86,0,1,1,7.719-.022v.022a3.86,3.86,0,1,1-7.719.022m6.832,0V223.3a3.008,3.008,0,0,0-2.984-3.124,2.972,2.972,0,0,0-2.962,3.1v.022a3.009,3.009,0,0,0,2.984,3.124,2.973,2.973,0,0,0,2.962-3.1",
    transform: "translate(-81.901 -86.884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3084",
    "data-name": "Path 3084",
    className: "cls-3",
    d: "M229.454,226.188a.384.384,0,0,1-.162-.324.413.413,0,0,1,.411-.422.381.381,0,0,1,.259.1,3.443,3.443,0,0,0,2.389.9c1.016,0,1.686-.541,1.686-1.286v-.022c0-.7-.379-1.1-1.967-1.438-1.741-.378-2.541-.94-2.541-2.183v-.022a2.234,2.234,0,0,1,2.487-2.065,3.859,3.859,0,0,1,2.41.746.441.441,0,0,1,.184.346.411.411,0,0,1-.411.411.4.4,0,0,1-.248-.075,3.164,3.164,0,0,0-1.957-.66c-.984,0-1.611.541-1.611,1.222v.022c0,.713.39,1.113,2.054,1.47,1.686.367,2.465.983,2.465,2.14v.021c0,1.3-1.081,2.14-2.584,2.14a4.42,4.42,0,0,1-2.865-1.016",
    transform: "translate(-90.807 -86.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3085",
    "data-name": "Path 3085",
    className: "cls-4",
    d: "M52.95,45.067s6.912-7.188,14.1-10.23A39.523,39.523,0,0,1,85.023,31.52c4.7.276,26.883,0,26.883,0s14.377.276,23.778-9.677A34.725,34.725,0,0,0,145.084,0H84.193S67.021.594,57.927,12.718c-4.147,5.53-6.409,10.793-6.912,19.354-.277,4.7,1.935,12.995,1.935,12.995",
    transform: "translate(-20.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3086",
    "data-name": "Path 3086",
    className: "cls-4",
    d: "M52.4,93.868a31.48,31.48,0,0,0,30.69,31.466V62.4A31.48,31.48,0,0,0,52.4,93.868",
    transform: "translate(-20.754 -24.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3087",
    "data-name": "Path 3087",
    className: "cls-5",
    d: "M144.895,64.375c0-.557-.019-1.109-.05-1.659h-30.64V93.648c.458.021.919.035,1.382.035a29.307,29.307,0,0,0,29.307-29.307",
    transform: "translate(-45.229 -24.838)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProyecto);
export default __webpack_public_path__ + "static/media/logo-proyecto.c164e7100dc17b4ebad2866e772d7e3f.svg";
export { ForwardRef as ReactComponent };